import {useLocale, useLogger} from '#imports';

const LANGUAGE_CODE_MIN_LENGTH = 2;
const LANGUAGE_CODE_MAX_LENGTH = 3;

export function useLanguageFormatter() {
    const {languageCode: displayLanguage} = useLocale();
    const logger = useLogger();

    function capitalizeFirstLetter(value: string): string {
        return value ? value[0].toUpperCase() + value.slice(1) : value;
    }

    function getLocalizedLanguageName(languageCode: string, defaultLanguageName?: string): string {
        try {
            if (languageCode && languageCode.length >= LANGUAGE_CODE_MIN_LENGTH && languageCode.length <= LANGUAGE_CODE_MAX_LENGTH) {
                const displayNames = new Intl.DisplayNames([displayLanguage.value], {
                    type: 'language',
                    fallback: 'none',
                });
                const translatedValue = displayNames.of(languageCode) ?? defaultLanguageName ?? languageCode;
                return capitalizeFirstLetter(translatedValue);
            }
        } catch (e) {
            logger.warn('Invalid language code: ', languageCode);
        }
        return defaultLanguageName ?? '';
    }

    return {
        getLocalizedLanguageName,
    };
}
